import { render, staticRenderFns } from "./termsAndConditions.vue?vue&type=template&id=f32a2b0c&scoped=true"
import script from "./termsAndConditions.vue?vue&type=script&lang=js"
export * from "./termsAndConditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32a2b0c",
  null
  
)

export default component.exports